import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';

import { countriesOptions } from '../../../data/OptionValues';

const CountrySelect = (props) => {

  const [install_country, setCountry] = useState(props.install_country);

  const handleCountryChanged = (event) => {
    setCountry(event.target.value);
    if (props.onChange) {
      props.onChange({"install_country": event.target.value});
    } else {
      console.error("Country changed handler not defined");
    }
  };

  useEffect(() => {
    setCountry(props.install_country);
  }, [props.install_country]);

  return (
    <TextField 
      select
      onChange={handleCountryChanged}
      disabled={props.disabled}
      value={install_country ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {countriesOptions?.sort((t1, t2) => {
        return t1.label < t2.label ? -1 : 1;
      }).map(op => {
        return <MenuItem key={op.value} value={op.value}>{op.label}</MenuItem>;
      })}
    </TextField>
  );
};

export default CountrySelect;